import { MessageSquare, Users, Search } from "lucide-react";
import SelectField from "../common/SelectField";
import SearchBar from "../common/SearchBar";

export default function PlainteHeader({ total, search, onSearch, statusFilter, onStatusChange }) {
  return (
    <div className="pageHeader">
      <div className="headerTop">
        <div className="pageTitle">
          <div className="titleWithIcon">
            <MessageSquare size={24} className="primaryIcon" />
            <h2>Plaintes & Support</h2>
          </div>
          <span className="countBadge">{total} plaintes</span>
        </div>
      </div>

      <div className="filterActionsRow">
        <div className="selectorsGrid">
          <SelectField
            icon={Users}
            value={statusFilter}
            onChange={onStatusChange}
            options={[
              { label: "Tous les statuts", value: "all" },
              { label: "En attente", value: "S01" },
              { label: "En cours", value: "S02" },
              { label: "Résolu", value: "S03" },
            ]}
          />
        </div>
        <div className="searchWrapper">
          <SearchBar
            value={search}
            onChange={onSearch}
            placeholder="Rechercher par sujet ou utilisateur..."
          />
        </div>
      </div>
    </div>
  );
}